<template>
  <a-modal
    v-model="visible"
    title="Add Child"
    @ok="handleSubmit"
    @cancel="handleCancel"
    okText="Add Child"
    :confirmLoading="confirmLoading"
  >
    <a-form :form="form">
      <!-- Show school code (read-only) -->
      <a-form-item label="School Code">
        <a-input :value="schoolCode" disabled />
      </a-form-item>

      <!-- Enrollment ID input -->
      <a-form-item label="Enrollment ID/Student ID/Admission ID">
        <a-input
          v-decorator="[
            'enrollment_id',
            { rules: [{ required: true, message: 'Please input enrollment ID!' }] }
          ]"
          placeholder="Enter Enrollment ID"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      parent: null,
      form: this.$form.createForm(this),
    }
  },
  computed: {
    ...mapState({
      schoolId: state => state.user.user.school.id, // ✅ from Vuex
      schoolCode: state => state.user.user.school.school_code,
    }),
  },
  methods: {
    showModal(parent) {
      this.parent = parent
      this.visible = true
    },
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          this.$http.post('/api/parent/addchild', {
            student_code: values.enrollment_id,
            school_code: this.schoolCode,
            registered_parent_id: this.parent.id,
            isMobile: 0,
          })
            .then(() => {
              this.$notification.success({
                message: 'Child Added Successfully',
                description: `Child Added to ${this.parent.name}`,
              })
              this.$emit('created')
              this.handleCancel()
            })
            .catch(err => {
              this.$neoNotify.error(err)
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
  },
}
</script>
